// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PDollarOutlinedSvg from "@fishx/icons-svg/es/asn/PDollarOutlined";
import FishxIcon from '../components/FishxIcon';

var PDollarOutlined = function PDollarOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PDollarOutlinedSvg
  }));
};

PDollarOutlined.displayName = 'PDollarOutlined';
export default React.forwardRef(PDollarOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PDollarOutlined.js
// module id = 3331
// module chunks = 0